const transitions = {
  transition: 'transitionend',
  OTransition: 'oTransitionEnd',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd',
}

const transitionEvent = () => {
  const el = document.createElement('el')

  return Object.keys(transitions).find((transition) =>
    el.style[transition] ? transition : undefined
  )
}

export const addEventListener = (node, func) => {
  if (!node) return
  node.addEventListener(transitionEvent(), func, false)
}

export const removeEventListener = (node, func) => {
  if (!node) return
  node.removeEventListener(transitionEvent(), func, false)
}
